import type { IPost } from "../../../../types/models/post.models.types";
import { usePutHttp } from "../../http.hook";

export interface IPostResponse {
  post: IPost;
}

interface IBody {
  eligibleForProductRefund: string;
}

export function useToggleProductRefundAdminHttp() {
  return usePutHttp<IBody, IPostResponse>({
    path: "/admin/posts/:id/eligible-product-refund",
  });
}
